import validateNumericInput from './helpers/validateNumericInput';

const calcRegularProfit = (amount, profitability, period) => {
  return amount * (profitability / 100) * period;
};

const calcCopytradingProfit = (amount, profitability, period, commission) => {
  return amount * (profitability / 100) * period * (commission / 100);
};

const initCopytradingCalculator = () => {
  const DECIMAL_DIGITS = 2;

  const form = document.querySelector('[data-calculator]');
  const initialAmountField = form.querySelector('#initial_amount');
  const commissionField = form.querySelector('#investment_commission');
  const profitabilityField = form.querySelector('#investment_profitability');
  const periodField = form.querySelector('#term');
  const investmentAmountField = form.querySelector('#investment_amount');

  const output = document.querySelector('[data-calculator-output]');
  const regularProfitCells = output.querySelectorAll('[data-profit]');
  const copytradingProfitCell = output.querySelector('[data-gc-invest-profit]');
  const totalCopytradingProfitCell = output.querySelector('[data-gc-invest-result]');

  [initialAmountField, commissionField, profitabilityField, investmentAmountField].forEach((field) => {
    field.addEventListener('keydown', (e) => validateNumericInput(e));
  });

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const initialAmountInUSD = parseFloat(initialAmountField.value) || 0;
    const commissionInPercent = parseFloat(commissionField.value);
    const profitabilityInPercent = parseFloat(profitabilityField.value);
    const periodInMonths = parseFloat(periodField.selectedOptions[0].value);
    const investmentAmountInUSD = parseFloat(investmentAmountField.value);

    const regularProfit = calcRegularProfit(initialAmountInUSD, profitabilityInPercent, periodInMonths);
    const copytradingProfit = calcCopytradingProfit(investmentAmountInUSD, profitabilityInPercent, periodInMonths, commissionInPercent);
    const totalCopytradingProfit = regularProfit + copytradingProfit;

    regularProfitCells.forEach((cell) => (cell.textContent = regularProfit.toFixed(DECIMAL_DIGITS)));
    copytradingProfitCell.textContent = copytradingProfit.toFixed(DECIMAL_DIGITS);
    totalCopytradingProfitCell.textContent = totalCopytradingProfit.toFixed(DECIMAL_DIGITS);
  });
};

export default initCopytradingCalculator;
